import { checkIfEventExists, loadEvents } from './utils/navigation-guards';

const children = [
  {
    name: 'calendar-week',
    path: '',
    components: {
      detailColumn: () => import('@web/pages/calendar/detail-column/Index.vue'),
    },
    meta: { 
      title: 'Agenda',
      showContent: true
    },
    beforeEnter: [loadEvents],
  },
  {
    name: 'calendar-week edit event',
    path: 'edit/:id',
    components: {
      detailColumn: () => import('@web/pages/calendar/detail-column/CalendarDetailColumnEditEvent.vue'),
    },
    meta: { title: 'Agenda' },
    beforeEnter: [loadEvents, checkIfEventExists],
  },
  {
    name: 'calendar-week edit recurring event',
    path: 'edit/:id',
    components: {
      detailColumn: () => import('@web/pages/calendar/detail-column/CalendarDetailColumnEditRecurrence.vue'),
    },
    meta: { title: 'Agenda' },
    beforeEnter: [loadEvents, checkIfEventExists],
  },
  {
    name: 'calendar-week add event',
    path: 'add',
    components: {
      detailColumn: () => import('@web/pages/calendar/detail-column/CalendarDetailColumnAddPage.vue'),
    },
    meta: { title: 'Agenda' },
    beforeEnter: [loadEvents],
  },
];

export default [
  {
    name: 'calendar-week-view',
    path: '/calendar/week/:year?/:week?/:day?',
    component: () => import('@web/pages/calendar/CalendarWeekView.vue'),
    meta: { title: 'Agenda' },
    redirect: { name: 'calendar-week' },
    children,
  },
];
